
	import Vue from "vue";
	import moment from "moment";
	import helpers from "../inc/helpers";
	import api from "../api";

	import TaxRate from "../data/TaxRate";
	import TaxEstimate from "../data/TaxEstimate";

	export default Vue.extend({
		props: ["disclaimer", "note"],

		data() {
			return {
				isLoading: true,
				form: {
					isSearching: false,
					values: {
						propertyTypes: ["Agricultural", "Commercial", "Industrial", "Residential"],
						taxRates: [] as Array<TaxRate>,
					},
					fields: {
						marketValue: null as null | string,
						propertyType: null as null | string,
						taxDistrict: null as null | TaxRate,
					},
					results: null as null | TaxEstimate,
					error: null as null | string,
				},
			};
		},

		mounted() {
			api.getTaxRates().then((taxRates: Array<TaxRate>) => {
				this.form.values.taxRates = taxRates;
				this.isLoading = false;
			});
		},

		methods: {
			submitForm() {
				if (this.form.fields.marketValue !== null && this.form.fields.propertyType !== null && this.form.fields.taxDistrict !== null) {
					this.form.isSearching = true;

					this.resetForm();

					let taxValues = new TaxEstimate(parseFloat(this.form.fields.marketValue), this.form.fields.propertyType, this.form.fields.taxDistrict);

					setTimeout(() => {
						this.form.results = taxValues;
						this.form.isSearching = false;
					}, 1000);
				} else {
					this.form.error = "Sorry, something went wrong. Please verify that it is correct and try again.";
				}
			},

			clearForm() {
				this.form.fields.marketValue = null;
				this.form.fields.propertyType = null;
				this.form.fields.taxDistrict = null;

				this.resetForm();
			},

			resetForm() {
				this.form.results = null;
				this.form.error = null;
			},
		},

		computed: {
			lastYear(): string {
				return moment()
					.subtract(1, "year")
					.format("Y");
			},

			thisYear(): string {
				return moment().format("Y");
			},

			isSearchReady(): boolean {
				return this.form.fields.marketValue !== null && this.form.fields.propertyType !== null && this.form.fields.taxDistrict !== null;
			},

			sortedTaxRates(): Array<TaxRate> {
				return this.form.values.taxRates.sort((a: TaxRate, b: TaxRate) => parseInt(a.gca_tax_rate_district_number) - parseInt(b.gca_tax_rate_district_number));
			},
		},

		filters: {
			formatCurrency(val: string) {
				return helpers.formatCurrency(val, false);
			},

			formatTaxDistrictNumber(number: number): string {
				return number.toString();
			},
		},
	});
